import PageLogin from '@/pages/auth/pageLogin'
import PageFindPwd from '@/pages/auth/pagePwdForget'
const routes = [
  {
    path: '/login',
    name: 'login',
    component: PageLogin
  },
  {
    path: '/findpwd',
    name: 'findpwd',
    component: PageFindPwd
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routers/auth.js